/**
 * @file flattenMenuItems.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-04-20
 * @modified 2026-04-20
 * @description Flatten the Dashboard's hierarchical menuItems tree into a single list that
 *              includes both top-level sections and their sub-items (skipping headers).
 *              Sub-items are returned with a `parentLabel` and `parentId` so callers can
 *              show parent context in pickers.
 */

export function flattenMenuItems(menuItems) {
  const list = [];
  for (const item of menuItems) {
    list.push(item);
    if (Array.isArray(item.subItems)) {
      for (const sub of item.subItems) {
        if (sub.isHeader) continue;
        list.push({
          ...sub,
          parentLabel: item.label,
          parentId: item.id
        });
      }
    }
  }
  return list;
}
